export function cap( str ) {

    const tmp2 = ( str || '' ).replace(/(.)([A-Z][a-z]+)/, '$1_$2').replace(/([a-z0-9])([A-Z])/, '$1_$2').toLowerCase()

	//const tmp = str.replaceAll( '_', ' ' )
	const tmp = tmp2.replaceAll( '_', ' ' )

	var splitStr = tmp.toLowerCase().split(' ');
	for (var i = 0; i < splitStr.length; i++) {
		splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
	}
	return splitStr.join(' '); 

}

export function humanFileSize( size, type ) {
	if ( type ) {
	    var i = size === 0 ? 0 : Math.floor( Math.log( size ) / Math.log( 1000 ) )
	    return ( size / Math.pow( 1000, i )).toFixed( 1 ) * 1 + ' ' + [ '', 'K', 'M', 'B', 'T' ][ i ]
	} else {
	    var i = size === 0 ? 0 : Math.floor( Math.log( size ) / Math.log( 1024 ) )
	    return ( size / Math.pow( 1024, i )).toFixed( 1 ) * 1 + ' ' + [ 'B', 'kB', 'MB', 'GB', 'TB' ][ i ]
	}
}

export function formatMonth( timestamp, monthFormat = 'short' ) {
	if ( !timestamp ) return ''
	const d = new Date( timestamp.substring( 0, 7 ) + '-15' )
	const options = { 
		year: 'numeric', 
		month: monthFormat, 
	}
	// "numeric", "2-digit", "narrow", "short", "long"
	return d.toLocaleDateString( "fi-FI", options )
}

export function formatDate( timestamp ) {
	if ( !timestamp || timestamp.length < 10 ) return ''
	//console.log( ' timestamp',  timestamp )
	const d = new Date( timestamp.substring( 0, 10 ) )
	const options = { 
		year: 'numeric', 
		month: 'numeric', 
		day: 'numeric', 
	}
	return d.toLocaleDateString( "fi-FI", options )
}

export function formatDatetime( timestamp ) {
	if ( !timestamp ) return ''
	const d = new Date( timestamp.substring( 0, 19 ) )
	//d.setTime( d.getTime() + ( 2 * 60 * 1000 ) )
	//console.log( timestamp, d )
	const options = { 
		year: 'numeric', 
		month: 'numeric', 
		day: 'numeric', 
		hour: 'numeric', 
		minute: 'numeric', 
		second: 'numeric', 
	}
	return d.toLocaleDateString( "fi-FI", options )
}

export function formatMoney( value, decimals = 2, locale = 'fi-FI' ) {
	//if ( !value ) return ''
	const formatter = new Intl.NumberFormat( locale, {
	  style: 'currency',
	  currency: 'EUR',
	  minimumFractionDigits: decimals || 0,
	  maximumFractionDigits: decimals || 0, 
	} )
	return formatter.format( Number( value ) )
}
